import { Requester } from './Requester';
import { IOrgRecord, IManifest } from '../types';

export const PostOrganization = async ({ client }: { client: IManifest }): Promise<IOrgRecord | null> => {
    try {
        const response = await Requester<IOrgRecord | null>({
            path: `organizations`,
            method: 'POST',
            payload: {
                clientOrganization: client
            }
        });

        return response && Object.hasOwn(response, '_id') ? (response as IOrgRecord) : null;
    } catch (e) {
        console.error('Create organization request failed');
        return Promise.reject(e);
    }
};
